(ns hai.knowledge.routes
  (:require
   [hai.knowledge.assistants.table :as assistants.table]
   [hai.knowledge.components.config-page :as config-page]
   [hai.ui.icons :as icons]
   hai.knowledge.api
   [hai.ui.rf-sugar :refer [>e]]
   [hai.web-app.routing :as routing]))

(defn routes []
  [["/knowledge"
    {:icon icons/outlined-auto_fix_high
     :label "AI assistants"
     ::routing/window-title "Assistants"}
    [""
     {:name        :tasks/knowledge
      :label       "Assistant Roles"
      :breadcrumbs ["Assistant Roles"]
      :view        assistants.table/page}]
    ["/crud/new" {:name :tasks/knowledge-crud-new
                  ::routing/window-title "New Assistant"
                  :view assistants.table/page}]
    ["/{ai-model-config/uuid}" {:name :tasks/knowledge-config
                                :breadcrumbs [:tasks/knowledge]
                                ::routing/window-title "Assistant Configuration"
                                :view config-page/config-page
                                :controllers [{:parameters {:path [:ai-model-config/uuid]}
                                               :start (fn [{ai-model-config :path}]
                                                        (>e [:entity/resolve ai-model-config {:request-id [:tasks/knowledge-config (:ai-model-config/uuid ai-model-config)]}]))}]}]
    ["/share/:token" {:name :assistant/private-link-access
                      :view assistants.table/page
                      :controllers [{:parameters {:path [:token]}
                                     :start (fn [{path :path}]
                                              (>e [:knowledge/accept-private-link (:token path)]))}]}]]])
